import React from "react";

const Grupo5 = ({datos,handleChange,eliminarFila}) => {

    return (

        <div>

            <div className="table-responsive">

                <table className="table align-middle">

                    <thead className="table-secondary">

                        <tr>

                            <th style={{ width: "70%" }}>Tipo de atención</th>
                            <th style={{ width: "180px" }}>Cantidad atendida</th>
                            <th style={{ width: "80px" }}>Acción</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            datos.length === 0 &&

                            <tr>

                                <td colSpan={3}  className="text-center">
                                    No hay registros. Presione "Agregar fila" para comenzar.
                                </td>

                            </tr>

                        }

                        {

                            datos.map((item, index) => (

                                <tr key={index}>

                                    <td>

                                        <select
                                            className="form-select"
                                            value={item.tipo_atencion || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "tipo_atencion",
                                                    e.target.value
                                                )
                                            }
                                        >

                                            <option value=""hidden> Seleccione</option>
                                            <option value="Línea base">Línea base</option>
                                            <option value="Jurídica">Jurídica</option>
                                            <option value="Medios de vida">Medios de vida</option>

                                        </select>

                                    </td>

                                    <td>

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.cantidad_atendida ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "cantidad_atendida",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td className="text-center">

                                        <button className="btn btn-sm btn-danger" onClick={() =>eliminarFila(index)}>
                                            <i className="bi bi-trash"></i>
                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default Grupo5;